export default "__VITE_ASSET__BoGdRe3F__"